import { render, staticRenderFns } from "./PaymentTermsNewForm.vue?vue&type=template&id=19f948ba"
import script from "./PaymentTermsNewForm.vue?vue&type=script&lang=js"
export * from "./PaymentTermsNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports